<template>
  <div class="sub-page">
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class="sub-content">
      <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="grid-wrap">
        <dx-data-grid
          ref="refInventoryGrid"
          :data-source="inventoryReceiptInfo"
          :show-borders="true"
          :showRowLines="false"
          :showColumnLines="true"
          :hover-state-enabled="true"
          :allowColumnResizing="true"
          column-resizing-mode="widget"
          :allow-column-reordering="true"
          :height="gridHeight"
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="true"
          :focused-row-key.sync="focusedRowKey"
          key-expr="seqId"
          @toolbar-preparing="onToolbarPreparing"
          @cell-prepared="onCellPreparedOutput"
          @row-removed="onRowRemoved"
          @row-removing="onRowRemoving"
          @row-inserted="onRowInserted"
          @row-inserting="onRowInserting"
          @row-updated="onRowUpdated"
          @row-updating="onRowUpdating"
          @editor-preparing="onEditorPreparing"
          @rowPrepared="onRowPrepared"
          @init-new-row="onInitNewRow"
          @focused-row-changed="onSelectionChanged"
        >
          <DxSearchPanel :visible="true" placeholder="검색..." />
          <DxExport :enabled="true" :file-name="exportTitle" />
          <DxEditing
            :allow-deleting="(userInfo.permission & crudAllow) > 0"
            :allow-updating="(userInfo.permission & crudAllow) > 0"
            :allow-adding="false"
            :use-icons="true"
            mode="raw"
          >
          </DxEditing>
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxColumnFixing :enabled="true" />
          <DxStateStoring
            :enabled="false"
            type="localStorage"
            storage-key="storage"
          />
          <DxColumn
            :allowEditing="isIdEdit"
            :fixed="false"
            caption="입고일"
            data-field="발생일자"
            dataType="date"
            format="yyyy-MM-dd"
            :editor-options="issueDateOption"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>

          <DxColumn
            :allowEditing="isIdEdit"
            caption="고객사"
            data-field="입고업체"
          >
            <DxLookup
              :data-source="companyInfoLookup"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :caption="$store.getters.getGroupName"
            data-field="차종"
            :visible="true"
            width="60"
          >
            <DxLookup
              :data-source="carTypeLookup"
              display-expr="모델코드"
              value-expr="모델코드"
            />
          </DxColumn>

          <DxColumn
            :allowEditing="isIdEdit"
            :fixed="false"
            caption="품번"
            data-field="품번"
            edit-cell-template="coilGridTemplate"
            width="110"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="품명"
            data-field="품명"
            :visible="true"
            width="190"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :fixed="false"
            caption="재질"
            data-field="재질"
            :visible="true"
            width="130"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :fixed="false"
            caption="두께"
            data-field="자사두께"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="가로"
            data-field="자사가로"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="세로"
            data-field="자사세로"
            :visible="true"
            width="60"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="isDeletableFlag"
            caption="중량"
            data-field="수량"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="isDeletableFlag"
            caption="코일수"
            data-field="코일수"
            :visible="true"
            format="#,##0"
            dataType="number"
            width="60"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="LOT_NO"
            data-field="lotNo"
            :visible="true"
            width="150"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="구매단가"
            data-field="가격"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="isDeletableFlag"
            caption="운반비"
            data-field="운반비"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요" />
          </DxColumn>
           <DxColumn
            :allowEditing="false"
            caption="구매금액"
            data-field="구매금액"
            :calculate-cell-value="calcAmount"
            :visible="true"
            format="#,##0"
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩처리"
            data-field="스크랩처리"
            :visible="true"
            width="80"
          >
            <DxLookup
              :data-source="scrapLookup"
              display-expr="코드명"
              value-expr="코드명"
            />
            <dx-required-rule v-if="isScarpInput" message="항목을 입력하세요" />
          </DxColumn>
           <DxColumn
            :allowEditing="true"
            :fixed="false"
            caption="마감월"
            data-field="마감일자"
            dataType="date"
            format="yyyy-MM"
            width="80"
            :editor-options="{calendarOptions: {maxZoomLevel: 'year', minZoomLevel: 'century'}}"
          >
            <dx-required-rule message="항목을 선택하세요" />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="NO"
            data-field="seqId"
            width="50"
            sort-order="desc"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="구분"
            data-field="자작"
            width="50"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            caption="입출구분"
            data-field="입출고구분"
            :visible="true"
          >
            <DxLookup
              :data-source="receiptTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="그룹번호"
            data-field="발주번호"
            width="50"
          >
          </DxColumn>
          <DxColumn
            :allowEditing="false"
            :visible="false"
            caption="재질품번"
            data-field="재질품번"
            width="50"
          >
          </DxColumn>

          <!-- <DxColumn width="90" :buttons="editSubButtons" type="buttons" /> -->
          <DxSummary>
            <DxTotalItem
              value-format="#,##0"
              column="발생일자"
              display-format="{0} (건)"
            />
            <DxTotalItem
              value-format="#,##0"
              summary-type="sum"
              column="수량"
              display-format="{0}"
            />
            <DxTotalItem
              value-format="#,##0"
              summary-type="sum"
              column="구매금액"
              display-format="{0}"
            />
          </DxSummary>
          <dx-paging :enabled="false" />
          <dx-scrolling
            mode="virtual"
            showScrollbar="always"
            :useNative="false"
          />
          <dx-sorting mode="multiple" />
          <template #coilGridTemplate="{ data: cellInfo }">
            <CoilGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-pcode="setCoilCode"
              :productionInfo="coilInfoList"
            />
          </template>
        </dx-data-grid>
      </div>
      <loading
        :active.sync="isLoading"
        color="rgb(2, 110, 156)"
        loader="bars"
      ></loading>
    </div>
    <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxFilterRow,
  DxColumnFixing,
  DxTotalItem,
  DxLookup,
  DxSummary,
  DxColumn,
  DxPaging,
  DxSorting,
  DxSearchPanel,
  DxExport,
  DxEditing,
  DxStateStoring
} from 'devextreme-vue/data-grid'
import { DxRequiredRule } from 'devextreme-vue/validator'
import CoilGridComponent from '../../share/component/CoilGridComponent'
import axios from 'axios'

export default {
  name: 'production-receipt',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      crudAllow: ConstDef.CRUD_ALLOW_구매,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '코일용도변경'
        }
      ],
      editSubButtons: null,
      inventoryReceiptInfo: null,
      selectedRow: null,
      thisYear: null,
      yearArray: [],
      thisMonth: null,
      monthArray: [],
      exportTitle: null,
      receiptTypeLookup: null,
      focusedRowKey: null,
      selectedVendor: null,
      processingTypeLookup: null,
      meterialTypeLookup: null,
      coilInfoList: null,
      외주사급코일정보: null,
      selectedCoilCode: null,
      companyInfoLookup: null,
      scrapLookup: null,
      isScarpInput: false,
      isIdEdit: true,
      carTypeLookup: null,
      maxSeqId: null,
      scrapPrice: null,
      showCompleted: false,
      isDeletableFlag: true,
      issueDateOption: null,
      scrapPriceAll: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxLookup,
    DxEditing,
    DxRequiredRule,
    DxStateStoring,
    CoilGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = AppLib.getThisYear()
    for (let i = this.thisYear; i >= 2021; i--) {
      this.yearArray.push({ year: i })
    }
    this.thisMonth = AppLib.getThisMonth()
    for (let i = 1; i <= 12; i++) {
      if (i > 0 && i < 10) {
        this.monthArray.push({ name: i + '월', value: '0' + i })
      } else {
        this.monthArray.push({ name: i + '월', value: '' + i })
      }
    }
    this.issueDateOption = { calendarOptions: { min: `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01` } }
    this.scrapLookup = ConstDef.SCRAP_LOOKUP
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.자재유형
    )
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(
      ConstDef.공정유형
    )
    this.receiptTypeLookup = ConstDef.COIL_INOUT_CODE
    console.log(this.receiptTypeLookup)
    this.companyInfoLookup = this.$_.sortBy(
      this.$store.getters.getFirstVendor,
      '거래처명'
    )
    this.companyInfoLookup.push({
      거래처명: '시중구매',
      거래처코드: '시중구매'
    })
    this.badCauseOption = {
      items: ConstDef.BAD_COIL_CAUSE,
      valueExpr: '코드명',
      displayExpr: '코드명'
    }
    this.refreshScrapPriceAll()
    this.refreshCoilInfo()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {},
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    calcAmount (row) {
      return row.수량 * (row.가격 + row.운반비)
    },
    checkScrapEditable (e) {
      console.log(e)
      return this.isScarpInput
    },
    isAddable () {
      // const result = AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
      this.isDeletableFlag = AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`)
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.type === 'buttons') {
        if (AppLib.isInOutCRUDable(`${this.thisYear}-${this.thisMonth}-01`) && !this.showCompleted) {
          // this.$Q(e.cellElement).show()
          this.$Q('.dx-link-delete').show()
          this.$Q('.dx-link-edit').show()
        } else {
          this.$Q('.dx-link-delete').hide()
          this.$Q('.dx-link-edit').hide()
        }
      }
      if (e.rowType === 'data' && e.column.dataField === '입출고구분') {
        if (
          e.data.입출고구분 === this.$_.findWhere(ConstDef.PRODUCTION_INOUT_CODE, { 코드명: '제품반품' }).코드
        ) {
          // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
      if (
        e.rowType === 'data' &&
        e.column.type !== undefined &&
        e.column.type === 'buttons'
      ) {
        if (e.data.사용유무) {
          this.$Q(e.cellElement)
            .find('.dx-icon-showpanel')
            .hide()
        }
      }
    },
    onInitNewRow (row) {
    },
    onEditorPreparing (e) {
      if (e.dataField === 'lotNo' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
        console.log(this.isIdEdit)
      }
    },
    onRowPrepared (e) {},
    onRowInserted (row) {
    },
    onRowInserting (row) {
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteSqlProc('창고수불', [{ 발주번호: row.data.발주번호 }])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
          this.refreshInventoryList()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (row) {
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      let 구입가 = 0
      console.log(row.data)
      if (row.data.입고업체 === ConstDef.시중구매) {
        구입가 = row.data.가격
      }
      const param = [
        {
          발주번호: row.data.발주번호,
          발생일자: row.data.발생일자,
          수량: row.data.수량,
          코일수: row.data.코일수,
          운반비: row.data.운반비,
          구입가: 구입가,
          lotNo: row.data.lotNo,
          스크랩처리: row.data.스크랩처리,
          updatetime: row.data.updatetime,
          updateid: row.data.updateid
        }
      ]
      // const paramOut = [
      //   {
      //     발주번호: row.data.발주번호,
      //     발생일자: row.data.발생일자,
      //     수량: row.data.수량,
      //     입출고구분: ConstDef.사급출고,
      //     코일수: row.data.코일수,
      //     구입가: 구입가,
      //     lotNo: row.data.lotNo,
      //     스크랩처리: row.data.스크랩처리,
      //     updatetime: row.data.updatetime,
      //     updateid: row.data.updateid
      //   }
      // ]
      const inProc = this.$_sp.runUpdateSqlProc('창고수불', ['발주번호'], null, param)
      axios.all([inProc])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
          this.refreshInventoryList()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      let firstDay = `${AppLib.getToday().substring(0, 7)}-01 00:00:00`
      firstDay = AppLib.getTimestampFromString(firstDay)
      if (!AppLib.isInOutCRUDable(row.oldData.발생일자) && row.newData.수량 !== undefined) {
        this.$snotify.info('전전월 입고일자의 중량은 변경할 수 없습니다.')
        row.cancel = true
      }
      if (row.newData.발생일자 !== undefined) {
        if (row.newData.발생일자 < firstDay) {
          this.$snotify.info('발생일자는 전월로 변경할 수 없습니다.')
          row.cancel = true
        }
      }
      if (row.newData.마감일자 !== undefined) {
        this.$_sp
          .runUpdateSqlProc('창고수불', ['seqId'], null, [
            { seqId: row.oldData.seqId, 마감일자: row.newData.마감일자 }
          ])
          .then(data => {
            console.log(`마감일자 수정 ${row.newData.마감일자}`)
          })
      }
      if (row.newData.가격 !== undefined && (row.newData.가격 === 0 || row.newData.가격 === null)) {
        if (row.newData.입고업체 === ConstDef.시중구매) {
          this.$snotify.info('시중구매시 구매단가를 입력하여 주세요.')
          row.cancel = true
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>연도 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.yearArray,
            valueExpr: 'year',
            displayExpr: 'year',
            value: this.thisYear,
            onValueChanged: args => {
              this.$store.commit('deleteInoutList')
              this.thisYear = args.value
              this.isAddable()
              this.refreshInventoryList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxSelectBox',
          options: {
            width: 80,
            items: this.monthArray,
            valueExpr: 'value',
            displayExpr: 'name',
            value: this.thisMonth,
            onValueChanged: args => {
              this.$store.commit('deleteInoutList')
              this.thisMonth = args.value
              this.isAddable()
              this.refreshInventoryList()
            }
          }
        }
      )
    },
    makeCarModelLookup () {
      const model = this.$_.uniq(this.inventoryReceiptInfo, item => item.차종)
      this.carTypeLookup = []
      model.forEach(item => {
        if (item.차종 !== null) {
          this.carTypeLookup.push({
            모델코드: item.차종
          })
        }
      })
      this.carTypeLookup = this.$_.sortBy(this.carTypeLookup, '모델코드')
    },
    refreshCoilInfo () {
      // spFindAllCoilInfo
      const coil = this.$_sp.runNoEncodeFindProc('spFindAllCoilInfo', { 기준일: `${this.thisYear}=${this.thisMonth}-01` })
      const sagup = this.$_sp.runNoEncodeFindProc('spFindAll외주품CoilInfo', { 기준일: `${this.thisYear}=${this.thisMonth}-01` })
      axios.all([coil, sagup])
        .then(axios.spread((...reponse) => {
          this.coilInfoList = this.$_sp.MakeModel(reponse[0])
          // console.log(this.coilInfoList)
          this.외주사급코일정보 = this.$_sp.MakeModel(reponse[1])
          // console.log(this.외주사급코일정보)
          const index = this.$_.findIndex(this.coilInfoList, { 품번: 'SCRAP' })
          this.scrapPrice = this.coilInfoList[index].가격
          this.coilInfoList.splice(index, 1)
          this.refreshInventoryList()
        }))
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshInventoryList () {
      this.exportTitle = `${this.thisYear}-${this.thisMonth}-원자재수불`
      this.isLoading = true
      let endDate = `${this.thisYear}-${
        this.thisMonth
      }-${AppLib.getMonthLastDay(this.thisYear, this.thisMonth)}`
      endDate = AppLib.calcDateFromFormat(endDate, 1)
      let param = {
        startDate: `${this.thisYear}-${this.thisMonth}-01`,
        endDate: `${endDate}`,
        품목유형: ConstDef.구매품,
        자재유형: ConstDef.자재유형_원자재,
        거래처코드: 'ALL',
        마감: 0
      }
      if (this.showCompleted) {
        param.마감 = 1
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInventoryReceiptByDateAndGoodsType', param)
        .then(data => {
          this.isLoading = false
          this.inventoryReceiptInfo = this.$_sp.MakeModel(data)
            .filter(item =>
              item.입출고구분 === ConstDef.용변입고 || item.입출고구분 === ConstDef.용변출고
            )
          console.log(this.inventoryReceiptInfo)
          const where = this.$_.where(this.inventoryReceiptInfo, {
            품번: 'SCRAP'
          })
          where.forEach(item => {
            let where = this.$_.find(this.scrapPriceAll, function (price) {
              return price.적용일자 <= item.발생일자 && price.만료일자 > item.발생일자
            })
            item.가격 = where.가격
          })
          const max = this.$_.max(this.inventoryReceiptInfo, function (item) {
            return item.seqId
          })
          this.maxSeqId = max.seqId
          if (this.focusedRowKey === null) {
            this.focusedRowKey = max.seqId
          }
          // this.searchEmptyPressSize(this.inventoryReceiptInfo)
          this.makeCarModelLookup()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPriceAll () {
      this.$_sp.runNoEncodeFindSqlProc('스크랩코일가격', { 재질: 'SCRAP' })
        .then(data => {
          this.scrapPriceAll = this.$_sp.MakeModel(data)
          console.log(this.scrapPriceAll)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // set emit
    setCoilCode (code) {
      // console.log(code)
      this.selectedCoilCode = code
    }
  }
}
</script>

<style lang="scss"></style>
